import { graphql, useStaticQuery } from 'gatsby'

export const useEmployeeStories = () => {
  const { employeeStories } =
    useStaticQuery<Queries.useEmployeeStoriesQueryQuery>(graphql`
      query useEmployeeStoriesQuery {
        employeeStories: allWpTeamMember(
          filter: {
            details: { employeeStory: { employeeStoryEnabled: { eq: true } } }
          }
        ) {
          nodes {
            id
            title
            featuredImage {
              node {
                gatsbyImage(width: 640)
              }
            }
            details {
              position
              employeeStory {
                quote
                story
              }
            }
          }
        }
      }
    `)

  return {
    employeeStories: employeeStories.nodes,
  }
}
